import React, { useEffect } from 'react';
import simpleChart from '../../../utils/simple-chart';

import './DataDialog.scss';

export interface TableData {
  key: string;
  value: string;
}

export interface GraphData {
  key: string;
  value: string;
}

export interface GraphItem {
  title: string;
  data: GraphData[];
  color?: string | string[];
  borderColor?: string | string[];
  step?: number;
  type?: string;
  displayY?: boolean;
  datasetLabel: string;
  tooltipCallback: (tooltipItems: any, data: any) => string;
}

export interface Props {
  table?: TableData[];
  graphs?: GraphItem[];
}

let graphIndex = 0;

const renderGraph = (graph: GraphItem) => {
  if (graph.data.length === 0) return '';
  const result = (
    <div className="data-graph mb-5">
      <canvas id={'graph-' + graphIndex} style={{ height: '400px', width: '100%' }}></canvas>
    </div>
  );
  graphIndex++;
  return result;
}

const renderTable = (table: TableData[]) => {
  if (table.length === 0) return '';
  return (
    <div className="data-table">
      <ul>
        {table.map(item => (
          <li className="row" key={item.key}>
            <div className="col-5">{item.key}</div>
            <div className="col-7">{item.value}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}

const DataDialog = ({ table = [], graphs = [] }: Props) => {
  useEffect(() => {
    for (let i = 0; i < graphs.length; i++) {
      const item = graphs[i];
      const values = item.data.map(x => x.value) as any;
      const maxValue = Math.max(...values);
      simpleChart('graph-' + i, {
        values,
        title: item.title,
        type: item.type,
        backgroundColor: item.color,
        step: item.step,
        max: maxValue + Math.ceil((maxValue / 10)),
        labels: item.data.map(x => x.key),
        tooltipCallback: item.tooltipCallback,
        displayY: item.displayY,
        datasetLabel: item.datasetLabel,
        borderColor: item.borderColor
      });
      graphIndex = 0;
    }
  });
  const margin = (graphs.length) > 0 ? 'mb-4' : '';
  return (
    <div className="cmp-data-dialog">
      <div className={margin}>
        {renderTable(table)}
      </div>
      {graphs.map(graph => (
        <React.Fragment key={graph.title}>
          {renderGraph(graph)}
          <hr style={{ margin: '1rem 0 2rem 0' }} />
        </React.Fragment>
      ))}
    </div>
  );
}

export default DataDialog;
